import { MatTable } from '@angular/material/table';
import { IRenderRow, TableColumnType } from '../model/model';
import { IPoint } from './selector';
const toolbarShowDelay = 300;
export class Header {
	current: IPoint;
	columns: TableColumnType[];
	_tableColumns: TableColumnType[];
	displayColumns: TableColumnType[];
	displayColumnNames: string[];
	headerToolbarShowTimer: NodeJS.Timer;
	tabDataOrg: MatTable<IRenderRow>;
	readonly fixStartColumns: TableColumnType[];
	readonly fixEndColumns: TableColumnType[];
	headerMouseenter(col: TableColumnType, event: MouseEvent) {
		this.current.x = (<HTMLTableCellElement>event.target).cellIndex;

		this.headerToolbarShowTimer = setTimeout(() => {
			col.showToolbar = true;
		}, toolbarShowDelay);
	}
	headerMouseleave(col: TableColumnType) {
		if (this.headerToolbarShowTimer) {
			clearTimeout(this.headerToolbarShowTimer);
			this.headerToolbarShowTimer = undefined;
		}
		col.showToolbar = false;
	}
	lockButtonClick(event: MouseEvent, col: TableColumnType) {
		col.sticky = true;
		col.showToolbar = false;
		this.syncColumn();
		event.stopPropagation();
		event.preventDefault();
	}
	unlockButtonClick(event: MouseEvent, col: TableColumnType) {
		col.sticky = false;
		col.showToolbar = false;
		this.syncColumn();
		event.stopPropagation();
		event.preventDefault();
	}
	toLeftButtonClick(event: MouseEvent, col: TableColumnType) {
		const realIndex = col.index;
		const tmp = this.columns[realIndex];
		tmp.showToolbar = false;
		this.columns[realIndex] = this.columns[realIndex - 1];
		this.columns[realIndex - 1] = tmp;
		this.syncColumn();
		event.stopPropagation();
		event.preventDefault();
	}
	toRightButtonClick(event: MouseEvent, col: TableColumnType) {
		const realIndex = col.index;
		const tmp = this.columns[realIndex];
		tmp.showToolbar = false;
		this.columns[realIndex] = this.columns[realIndex + 1];
		this.columns[realIndex + 1] = tmp;
		this.syncColumn();
		event.stopPropagation();
		event.preventDefault();
	}
	/**è¿åä¸ä¸ªåæ¯ä¸æ¯åºå®åçæå³è¾¹å */
	stickyColumnRight(colIndex: number) {
		return (
			colIndex < this._tableColumns.length - 1 &&
			this._tableColumns[colIndex].sticky &&
			!this._tableColumns[colIndex + 1].sticky
		);
	}
	// åæ­¥åçè®¾ç½®ï¼ä¸»è¦æ¯éæ°æ ¹æ®åºå®åæå®é¡ºåº
	syncColumn() {
		/**åæä¸æ¬¡å­å¨çåç§æ ·è¾åº,æ³¨æä¿çåæçé¡ºåº */
		let cols = (this.columns || []).filter(
			col => this.displayColumns.find(vv => vv.Name === col.Name) !== undefined
		);

		/**åè¾åºå©ä¸çå */
		const cc = (this.displayColumns || []).filter(col => cols.find(vv => vv.Name === col.Name) === undefined);
		cols = cols.concat(cc);
		// æåºå®åæåå°æåé¢
		cols = cols.filter(v => v.sticky).concat(cols.filter(v => !v.sticky));
		cols.forEach((v1, idx) => (v1.index = idx));
		this.columns = cols;
		this._tableColumns = [...this.fixStartColumns].concat(
			/**åºå®çåæå¨åé¢ */
			this.columns,
			this.fixEndColumns
		);
		this.displayColumnNames = this._tableColumns.map(vv => vv.Name);
		/**å¦èï¼ååå®¹ååï¼å®½åº¦è¿æ¯ç®ä¸ä¸æ¬¡çï¼é æåå®½è®¡ç®ä¸å¯¹ï¼åªæåéçå»¶åè°ç¨ä¸æ¬¡å¼ºå¶æ´æ° */
		setTimeout(() => {
			this.tabDataOrg.updateStickyColumnStyles();
		}, 10);
	}
}
